import * as React from "react";
import { Redirect } from "react-router-dom";
import Sidenav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import ClickOutside from "react-click-outside";
import { CSSTransition } from "react-transition-group";
import Loader from "react-loader";

import {
  currentBaseUrl,
  currentUser,
  currentUserAge,
  currentUserSchool,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
} from "../../../common/services";

import NavBar from "../../../components/CustomNav/CustomNav.Component";
import ResponsesTile from "../../../common/responsesTile.Component";
import TraitTile from "../../../common/traitTile.Component";
import PerceptionsTile from "../../../common/perceptionsTile.Component";

import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import "./parentDataCenter.css";

// dummy data
import {
  response,
  breakdownResponse,
} from "../../../assets/data/sampleResults";
import CustomDonutChart from "../../../common/DataViz/customDonutChart.Component";
import withServices from "src/HOCs/withServices";

import { tourSteps } from "./ParentDataCenterTour";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
// import { ToastContainer, toast } from "react-toastify";
interface IProps {
  history?: any;
  services?: any;
  match?: any;
}
class ParentDataCenter extends React.Component<IProps> {
  public state = {
    sideNavOpen: false,
    sideNavCategory: "summary", // should be similar to user id's (child 1, child 2, dad etc)
    currentassessmentid: "0",
    toComparisons: false,
    toPostUpgradeDc: false,
    children: [] as any,
    childrenLoaded: false,
    parentAssessmentInfo: null as any,
    parentAssessmentLoaded: false,
    currentChildAssessment: null,
    currentChildLoaded: false,
    currentChildName: "",
    parentCompleteAssessments: [] as any,
    selectedParentAssessmentID: null,
    currentChildID: null,
    currentChildInfo: null as any, // completed assessment info
    currentChildAssessments: [] as any, // completed assessments
    childAssessmentInfoLoaded: false, // for assessment info
    childAssessmentsLoaded: false, // for assessments list
    currentChildHasCompleteAssessement: false,
    toLogin: false,
    guidesRead: true,
  };

  constructor(props) {
    super(props);
    this.getCategoryViz = this.getCategoryViz.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.getAssessmentsViz = this.getAssessmentsViz.bind(this);
    this.getSummaryViz = this.getSummaryViz.bind(this);
    this.toggleSideNav = this.toggleSideNav.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.handleAssessmentChosen = this.handleAssessmentChosen.bind(this);
    this.toComparisons = this.toComparisons.bind(this);
    this.toSearchFilters = this.toSearchFilters.bind(this);
    this.toPostUpgradeDc = this.toPostUpgradeDc.bind(this);
    // this.handleAssessmentChosen = this.handleAssessmentChosen.bind(this);
    this.onChildItemClick = this.onChildItemClick.bind(this);
  }

  public async componentDidMount() {
    const {
      services: { adminAPI, parentsAPI, currentUserID, isUserLoggedIn },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
    const childID = this.props.match.params.childid;

    let sideNavCategory = "summary";
    let currentChildName = "";

    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}DataCenterTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }

    // fetcch parent's children & parent's assessments list
    const [childrenRes, parentAssessmentRes] = await Promise.all([
      parentsAPI.getChildren(currentUserID),
      adminAPI.getUserAssessmentsList(currentUserID),
    ]);
    if (childrenRes.ok) {
      const children = childrenRes.data.children;
      const parentCompleteAssessments = parentAssessmentRes.data.assessments;
      const assessmentID = parentAssessmentRes.data.assessments[0].id;
      const assessmentRes = await adminAPI.getUserNoGroupResults(
        currentUserID,
        assessmentID
      );
      let parentAssessmentInfo = null;
      if (assessmentRes.ok) {
        parentAssessmentInfo = assessmentRes.data;
      }
      if (typeof childID !== "undefined") {
        const child = children.find((c) => c.id === +childID);
        currentChildName = child.first_name;
        sideNavCategory = "child-assessments";
      }
      this.setState({
        children,
        childrenLoaded: true,
        parentAssessmentInfo,
        parentAssessmentLoaded: true,
        parentCompleteAssessments,
        selectedParentAssessmentID: assessmentID,
        currentChildName,
        sideNavCategory,
        guidesRead
      });
      if (typeof childID !== "undefined") {
        this.onChildItemClick(+childID, currentChildName);
      }
    }
  }

  public onLogout = () => {
    this.setState({ toLogin: true });
  };

  public toProfile = () => {
    const { history } = this.props;
    history.push(currentBaseUrl() + "profilepage");
  };

  public toPostUpgradeDc() {
    this.setState({ toPostUpgradeDc: true });
  }

  // close side nav on click outside
  public onClickOutside() {
    this.setState({ sideNavOpen: false });
  }

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}DataCenterTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  // content methods
  public chooseCategory(evtKey, event) {
    const { currentChildName } = this.state;
    let name = "";
    if (evtKey !== "summary") {
      name = currentChildName;
    }
    this.setState({ sideNavCategory: evtKey, currentChildName: name });
  }

  public toggleSideNav() {
    const navstate = this.state.sideNavOpen;
    this.setState({ sideNavOpen: !navstate });
  }

  public toComparisons() {
    const history: any = this.props.history || {};
    history.push("/parents/comparisons");
    // this.setState({toComparisons: true});
  }
  public toSearchFilters() {
    const history: any = this.props.history || {};
    history.push("/parents/search-filters");
    // this.setState({toComparisons: true});
  }

  public async onChildItemClick(childID, firstName) {
    // get the child's completed assessments
    const {
      services: { adminAPI },
    } = this.props;
    const assessmentRes = await adminAPI.getUserAssessmentsList(childID);
    if (assessmentRes.ok) {
      let assID = null;
      let currentChildHasCompleteAssessement = false;
      if (assessmentRes.data.assessments.length > 0) {
        assID = assessmentRes.data.assessments[0].id;
        currentChildHasCompleteAssessement = true;
      } else {
        // toast.warn("This child has not done an assessment yet!");
        currentChildHasCompleteAssessement = false;
        this.setState({
          currentChildHasCompleteAssessement,
          currentChildName: firstName,
        });
        return;
      }

      const assInfoRes = await adminAPI.getUserNoGroupResults(childID, assID);
      let currentInfo = {};
      if (assInfoRes.ok) {
        currentInfo = assInfoRes.data;
      }

      this.setState({
        currentChildInfo: { ...currentInfo },
        currentChildID: childID,
        currentChildName: firstName,
        currentChildAssessments: assessmentRes.data.assessments,
        childAssessmentInfoLoaded: true,
        childAssessmentsLoaded: true,
        currentChildAssessment: assID,
        currentChildHasCompleteAssessement,
      });
    }
  }

  public async handleChildAssessmentChosen(e) {
    const { currentChildAssessment, currentChildID } = this.state;
    const {
      services: { adminAPI },
    } = this.props;
    if (e.target.value !== currentChildAssessment) {
      this.setState({ childAssessmentsLoaded: false });
      const assessmentRes = await adminAPI.getUserNoGroupResults(
        currentChildID,
        e.target.value
      );
      if (assessmentRes.ok) {
        this.setState({
          currentChildInfo: { ...assessmentRes.data },
          childAssessmentsLoaded: true,
        });
      }
    }
  }

  public async handleAssessmentChosen(e) {
    const { selectedParentAssessmentID } = this.state;
    const {
      services: { adminAPI, currentUserID },
    } = this.props;
    if (e.target.value !== selectedParentAssessmentID) {
      this.setState({ parentAssessmentLoaded: false });
      const assessmentRes = await adminAPI.getUserNoGroupResults(
        currentUserID,
        e.target.value
      );
      if (assessmentRes.ok) {
        this.setState({
          parentAssessmentInfo: { ...assessmentRes.data },
          parentAssessmentLoaded: true,
        });
      }
    }
  }

  public renderGraphs = (results) => {
    return (
      <React.Fragment>
        <div className="student-center-row">
          <div className="student-perceptions">
            <PerceptionsTile
              results={results.results}
              services={this.props.services}
            />
          </div>
          <div className="student-responses">
            <ResponsesTile responseData={results.results} />
          </div>
        </div>
      </React.Fragment>
    );
  };

  public renderCurrentParentViz = () => {
    const { parentAssessmentInfo, parentAssessmentLoaded } = this.state;
    if (parentAssessmentLoaded) {
      return this.renderGraphs(parentAssessmentInfo);
    } else {
      return <Loader loaded={parentAssessmentLoaded} color="#3ee9f7" />;
    }
  };

  public getCategoryViz() {
    if (this.state.sideNavCategory === "summary") {
      return this.getSummaryViz();
    }
    // else if (this.state.sideNavCategory === "my-assessments") {
    // return this.getAssessmentsViz(this.state.sideNavCategory);
    // }
    else if (this.state.sideNavCategory === "child-assessments") {
      return this.renderChildrenViz();
    } else {
      return (
        <h2
          style={{
            marginTop: "10%",
            fontSize: "24px",
            textAlign: "center",
          }}
          className="selected-assessment"
        >
          <span>NO DATA TO SHOW YET!</span>
          <br />
          MAKE SURE YOU HAVE ADDED CHILDREN TO YOUR SUBSCRIPTION <br />
        </h2>
      );
    }
  }

  public getSummaryViz() {
    const {
      parentAssessmentInfo,
      parentAssessmentLoaded,
      children,
      parentCompleteAssessments,
    } = this.state;
    if (parentAssessmentLoaded) {
      return (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="p-data-summary">
            <div className="p-center-header-row">
              <h1 className="dashboard-name">
                PROGRESS AND ATTAINMENT DASHBOARD
              </h1>
              {/* <button className="green-button upgrade" onClick={this.openWidget.bind(this, "packages")}>UPGRADE <br/>NOW</button> */}
            </div>
            <div className="p-center-header-row step-5">
              <h1 className="dashboard-name">ASSESSMENTS RESULTS</h1>
              <p className="data-guide">
                Choose an <span>assessment</span>
              </p>
              {/* <div className="student-center-row"> */}
              <select
                onChange={this.handleAssessmentChosen}
                style={{ width: "500px" }}
                name="student-assessments"
                id="student-assessments"
                className="custom-select assessments-select"
              >
                {parentCompleteAssessments.map((d) => (
                  <option
                    key={d.id}
                    value={d.id}
                    selected={d.id === this.state.selectedParentAssessmentID}
                  >
                    {d.Title}
                  </option>
                ))}
              </select>
            </div>
            <div className="p-center-row">
              <div className="p-summary p-summary-left">
                <h2 className="tile-name">SUMMARY</h2>
                <div className="summary-details">
                  <div className="summary-detail">
                    <h4 className="detail-name">Number of Children</h4>
                    <div className="p-learner">
                      <p className="p-children" style={{ margin: "0" }}>
                        {children.length}
                      </p>
                    </div>
                  </div>
                  <div className="summary-detail">
                    <h4 className="detail-name">
                      Your Performance Learning Score
                    </h4>
                    <CustomDonutChart
                      color="#000"
                      value={parentAssessmentInfo.results.PLOAScore}
                      text={Math.round(parentAssessmentInfo.results.PLOAScore)}
                      alertLevel={parentAssessmentInfo.results.RiskLevel}
                    />
                  </div>

                  {/* <div className="summary-detail">
                  <h4 className="detail-name">Complete Assessments</h4>
                  <div id="value-border1">
                    <p style={{ margin: "0" }} className="complete-assessments">
                      1
                    </p>
                  </div>
                  <h4 className="detail-name">Incomplete Assessments</h4>
                  <div id="value-border2">
                    <p
                      style={{ margin: "0" }}
                      className="incomplete-assessments"
                    >
                      2
                    </p>
                  </div>
                </div> */}
                </div>
              </div>
              <div className="p-trait p-summary-right step-3">
                <h2 className="trait-tile-name">YOUR PERFORMANCE LEARNING SCORE AND PROFILE</h2>
                <TraitTile
                  results={parentAssessmentInfo.results}
                  vimeoModel="parents"
                />
              </div>
              {/* end summary left */}
            </div>

            <div className="p-center-row">
              <div className="parent-perceptions step-6">
                <PerceptionsTile
                  results={parentAssessmentInfo.results}
                  services={this.props.services}
                />
              </div>
              <div className="parent-responses step-4">
                <ResponsesTile responseData={parentAssessmentInfo.results} />
              </div>
            </div>
          </div>
        </CSSTransition>
      );
    } else {
      return "";
    }
  }

  public getAssessmentsViz(userKey) {
    // use user key (sidenav cateogory to feed the right data)
    const {
      parentCompleteAssessments,
      parentAssessmentLoaded,
      parentAssessmentInfo,
    } = this.state;
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="student-assessments-data">
          <div className="student-center-header">
            <h1 className="dashboard-name">ASSESSMENTS RESULTS</h1>
            <p className="data-guide">
              Choose an <span>assessment</span>
            </p>
            {/* <div className="student-center-row"> */}
            <select
              onChange={this.handleAssessmentChosen}
              style={{ width: "500px" }}
              name="student-assessments"
              id="student-assessments"
              className="custom-select assessments-select"
            >
              {parentCompleteAssessments.map((d) => (
                <option
                  key={d.id}
                  value={d.id}
                  selected={d.id === this.state.selectedParentAssessmentID}
                >
                  {d.Title}
                </option>
              ))}
            </select>

            {/* <button className="save-report blue-button">SAVE REPORT</button> */}
            <h2 className="selected-assessment">
              Assessment{" "}
              <span> {parentAssessmentInfo.assessment_info.Title}</span>
            </h2>
          </div>
          {/* </div> */}

          {this.renderCurrentParentViz()}
        </div>
      </CSSTransition>
    );
  }

  public renderChildrenViz = () => {
    // use user key (sidenav cateogory to feed the right data)
    const {
      currentChildInfo,
      currentChildAssessments,
      currentChildAssessment,
      childAssessmentsLoaded,
      childAssessmentInfoLoaded,
      currentChildName,
      currentChildHasCompleteAssessement,
    } = this.state;
    if (childAssessmentInfoLoaded && currentChildHasCompleteAssessement) {
      return (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="student-assessments-data">
            <div className="student-center-header">
              <h1 className="dashboard-name">
                <span style={{ textTransform: "uppercase" }}>
                  {currentChildName}'s{" "}
                </span>
                ASSESSMENTS RESULTS
              </h1>
            </div>
            <div className="student-center-row">
              <div>
                <p className="data-guide">
                  Choose an <span>assessment</span>
                </p>
                <h2
                  className="selected-assessment"
                  style={{ textAlign: "center" }}
                >
                  Assessment{" "}
                  <span> {currentChildInfo.assessment_info.Title}</span>
                </h2>
                <select
                  onChange={this.handleChildAssessmentChosen}
                  style={{ width: "500px" }}
                  name="student-assessments"
                  id="student-assessments"
                  className="custom-select assessments-select"
                >
                  {currentChildAssessments.map((d) => (
                    <option
                      key={d.id}
                      value={d.id}
                      selected={d.id === currentChildAssessment}
                    >
                      {d.Title}
                    </option>
                  ))}
                </select>

                {/* <button className="save-report blue-button">SAVE REPORT</button> */}
              </div>
              <div className="p-trait p-summary-right">
                <h2 className="trait-tile-name">
                  {" "}
                  <span style={{ textTransform: "uppercase" }}>
                    {currentChildName}'s
                  </span>{" "}
                  PERFORMANCE LEARNING SCORE AND PROFILE
                </h2>
                <TraitTile
                  results={currentChildInfo.results}
                  vimeoModel="students"
                />
              </div>
            </div>
            {this.renderGraphs(currentChildInfo)}
          </div>
        </CSSTransition>
      );
    } else if (!currentChildHasCompleteAssessement) {
      return (
        <div className="student-assessments-data">
          <div className="student-no-assessment">
            <i className="fa fa-info-circle info-icon" />
            <p className="no-assessment-guide">
              <span>NEARLY THERE</span>
              <br />
              <br />
              <span>{currentChildName}</span> needs to complete their
              assessment, as soon as they have, come back and you can explore
              their result <br />
            </p>
          </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  };

  public render() {
    const { children, childrenLoaded } = this.state;
    if (this.state.toComparisons === true) {
      return <Redirect to={"/parents/comparisons"} />;
    }

    if (this.state.toPostUpgradeDc) {
      return <Redirect to="/parents/datacentre" />;
    }

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <div className="data-center">
        {/* <ToastContainer /> */}
        <NavBar profileParent={this.toProfile} logoutParent={this.onLogout} />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <ClickOutside onClickOutside={this.onClickOutside}>
          <Sidenav
            onSelect={this.chooseCategory}
            className="datacenter-nav step-1"
            expanded={this.state.sideNavOpen}
            onToggle={this.toggleSideNav}
          >
            <Sidenav.Toggle />
            <Sidenav.Nav defaultSelected="summary">
              <NavItem eventKey="summary">
                <NavIcon>
                  {/* icon goes here */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "summary"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    S
                  </span>
                </NavIcon>
                <NavText>Summary</NavText>
              </NavItem>
              {/* <NavItem eventKey="my-assessments">
                <NavIcon>
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "my-assessments"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    A
                  </span>
                </NavIcon>
                <NavText>My Assessments</NavText>
              </NavItem> */}
              {childrenLoaded
                ? children.map((child) => (
                    <NavItem
                      eventKey="child-assessments"
                      onClick={this.onChildItemClick.bind(
                        this,
                        child.id,
                        child.first_name
                      )}
                    >
                      <NavIcon>
                        <span
                          className="navicon"
                          style={
                            this.state.currentChildName === child.first_name
                              ? { color: "#ff0033" }
                              : { color: "#fff" }
                          }
                        >
                          {child.first_name[0]}
                          {child.last_name[0]}
                        </span>
                      </NavIcon>
                      <NavText>{child.first_name}'s Assessments</NavText>
                    </NavItem>
                  ))
                : ""}
              <NavItem eventKey="comparisons" onClick={this.toComparisons}>
                <NavIcon>
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "comparisons"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    CF
                  </span>
                </NavIcon>
                <NavText>Comparison Filters</NavText>
              </NavItem>
              <NavItem eventKey="searchfilters" onClick={this.toSearchFilters}>
                <NavIcon>
                  <span
                    className="navicon step-2"
                    style={
                      this.state.sideNavCategory === "searchfilters"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    SF
                  </span>
                </NavIcon>
                <NavText>Search Filters</NavText>
              </NavItem>
              {/* <NavItem eventKey="searchfilters" onClick={this.toPostUpgradeDc}>
                <NavIcon>
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "datacentre"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    DC
                  </span>
                </NavIcon>
                <NavText>Data Centre</NavText>
              </NavItem> */}
            </Sidenav.Nav>
          </Sidenav>
        </ClickOutside>

        <div className="data-container">{this.getCategoryViz()}</div>
      </div>
    );
  }
}

export default withServices(ParentDataCenter);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Parent/parentDataCenter.Component.tsx